module.exports = __webpack_public_path__ + "img/pop-left.5774becc.png";